export const UNSET = 'UNSET'

export const GOOD = '👍🏽'
export const BAD = '👎🏽'
export const CHOICE = '✏️'
